import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { RegistrationForm } from '@features/auth/components/registration-form/RegistrationForm';

import { W2Shell } from '../components/W2Shell';
import { W2AuthChrome } from './W2AuthChrome';
import { useW2FlowContext } from './W2FlowLayout';
import { useInvitePrefill } from './useInvitePrefill';
import { useW2Paths } from './paths';

export const W2RegisterRoute: React.FC = () => {
  const { runEnroll, employerToken } = useW2FlowContext();
  const navigate = useNavigate();
  const paths = useW2Paths();

  // Roster invite pre-fill (contract §Frontend): a personalized invite link
  // carries `?emp=<ref>` — an OPAQUE per-employee reference the portal exchanges
  // server-side for the roster row's name + email. W2IndexRedirect already
  // forwards the search string onto this route.
  const [searchParams] = useSearchParams();
  const prefill = useInvitePrefill(employerToken, searchParams.get('emp'));

  // Only an ACTUAL ref resolve holds the shell; the no-ref path settles
  // synchronously, so the register form renders with zero added delay (and the
  // 404 / failure path likewise falls through to the plain, editable form).
  if (prefill.phase === 'loading') {
    return (
      <W2Shell title="One moment…">
        <p className="text-[15px] text-[#5a5a70]">Loading your enrollment…</p>
      </W2Shell>
    );
  }

  return (
    <W2AuthChrome>
      <RegistrationForm
        onAuthenticated={runEnroll}
        onSwitchToLogin={() => navigate(paths.login)}
        prefill={prefill.data ?? undefined}
      />
    </W2AuthChrome>
  );
};
